export default __webpack_public_path__ + "static/media/undraw_under_construction_46pa.18ee8987.svg";